import React, { Component } from "react";
import kominfoRequirement from "../../assets/kominfo-syarat-psre.png";
import shieldOrange from "../../assets/shield-orange.png";
import shieldBlue from "../../assets/shield-blue.png";
import shieldGreen from "../../assets/shield-green.png";

export default class Recognition extends Component {
  render() {
    return (
      <section class="pengakuan-psre">
        <div class="container">
          <div class="card">
            <img
              class="card-img-top"
              src={kominfoRequirement}
              style={{ height: "200px", width: "auto" }}
            />
            <div class="card-body" style={{ padding: "30px 40px" }}>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "15px",
                  marginBottom: "20px",
                }}
              >
                Pengakuan PSrE Indonesia (Berinduk)
              </p>
              <p
                class="text-muted"
                style={{ marginBottom: "35px", fontSize: "13px" }}
              >
                Semua PSrE yang beroperasi di Indonesia wajib mendapatkan
                <br /> pengakuan dari Menteri Kominfo dengan berinduk ke PSrE
                Induk.
              </p>
              <div class="d-flex" style={{ flexWrap: "wrap" }}>
                <table class="table-borderless">
                  <tr>
                    <td>
                      <img
                        class="mr-3"
                        src={shieldGreen}
                        alt="shield-orange"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                    <td>
                      <span style={{ fontSize: "13px", fontWeight: "600" }}>
                        Berinduk
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
